import { AuthService } from 'services';
import {
  shouldUserSubscribe,
  subscriberUserForPushNotifications,
} from 'services/pushNotificationsService';

import { ACTION_TYPES } from './index';

export const __updateuser = (user) => (dispatch, getState) => {
  const { locals } = getState();

  if (shouldUserSubscribe()) {
    subscriberUserForPushNotifications(user, locals?.criteria);
  }
  return dispatch({
    type: ACTION_TYPES.UPDATE_USER_FULL,
    payload: user,
  });
};

export const updateAnonymousUser = (user) => ({
  type: ACTION_TYPES.UPDATE_ANONYMOUS_USER,
  payload: user,
});

export const updateUser = () => async (dispatch) => {
  return AuthService.getUserProfile()
    .then((response) => {
      dispatch(__updateuser(response));
    })
    .catch((error) => {
      console.error('error :', error);
    });
};
